import Layout from '@layout/Layout';
import MarkdownReader from '@reader/MarkdownReader';
import { typography } from './typographyStyles';

function SimpleContentLayout(props) {
  const { markdown, title } = props.content;

  return (
    <div>
      <div className="w-full bg-accent-3 pb-4 pt-6 md:pt-20">
        <h1 className="container mx-auto h-full max-w-3xl px-4 font-primary text-4xl font-light text-primary-dark md:text-5xl lg:px-0">
          {title}
        </h1>
      </div>
      <div className="container mx-auto max-w-3xl">
        <div className="z-0 mx-auto h-fit min-h-[400px] bg-functional-contrast pb-10 pt-4 md:container md:max-w-5xl lg:max-w-7xl">
          <MarkdownReader markdown={markdown} typography={props.typography} />
        </div>
      </div>
    </div>
  );
}
export default function SimpleContentPage(props) {
  const content = props.content;
  return (
    <Layout screenSize={false}>
      <SimpleContentLayout content={content} typography={typography} />
    </Layout>
  );
}
